import { applyPolyfills } from '@/utils/polyfills';

export default defineNuxtPlugin(() => {
  applyPolyfills();
});